import { formatDollarsCompact } from '../../lib/snapshotMetrics';

/**
 * Decorative 4-bar school-year trend; current (last) year highlighted.
 *
 * CRM-121: these bars are on their OWN money basis — full-season totals by school
 * year — and deliberately do not follow the YTD/season toggle. That is a third
 * basis on one screen, so the caption below names it rather than leaving a reader
 * to assume the bars and the tiles above are measuring the same thing.
 */
export function FundraiserTrendBars({ trend }: { trend: Array<{ label: string; raisedCents: string }> }) {
  if (trend.length === 0) return null;
  const maxTrend = Math.max(1, ...trend.map((t) => Number(BigInt(t.raisedCents))));
  return (
    <>
    <div className="px-4 pt-3 border-t border-gray-100 dark:border-gray-700/60 text-[11px] text-gray-500 dark:text-gray-400">
      Full school years — does not follow the toggle above
    </div>
    <div aria-hidden="true" className="px-4 pb-3 pt-1 flex items-end gap-3">
      {trend.map((t) => {
        const h = Math.round((Number(BigInt(t.raisedCents)) / maxTrend) * 44) + 2;
        const isCurrent = t === trend[trend.length - 1];
        return (
          <div key={t.label} className="flex flex-col items-center gap-1">
            <div className={`w-5 rounded-t ${isCurrent ? 'bg-blast-500' : 'bg-blast-100 dark:bg-blast-900'}`} style={{ height: `${h}px` }} title={formatDollarsCompact(t.raisedCents)} />
            <span className="text-[10px] text-gray-400 dark:text-gray-500">{t.label.replace('20', "'")}</span>
          </div>
        );
      })}
    </div>
    </>
  );
}
